import Swal from 'sweetalert2';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Noticias = {
    agregarNoticia: async (data) => {
        let url = url_json + "/noticia"
        let body = {
            imagen: data.imagen
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Noticia agregada correctamente' ,
              'success'
            ).then(() => {
              window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar la noticia, codigo: ' + res.message ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerNoticias: async () => {
        let url = url_json + "/noticia"
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerUnaNoticia: async id => {
        let url = url_json + "/noticia/" + id
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarNoticia: async (data, id) => {
        let url = url_json + "/noticia/" + id;
        let body = {
            imagen: data.imagen
        };
        let request = {
            method: 'PATCH',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();
        if (response.ok) {
            Swal.fire(
                'Modificación exitosa!',
                'Noticia modificada correctamente' ,
                'success'
            ).then(() => {
                window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo modificar la noticia' ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data };
    },
    eliminarNoticia: async id => {
        Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea eliminar la noticia?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let url = url_json + "/noticia/delete/" + id;
                let request = {
                    method: 'PATCH',
                    headers: {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                }

                let response = await fetch(url, request);
                let res = await response.json();
                if (response.ok) {
                    Swal.fire(
                        'Eliminación exitosa!',
                        'Noticia eliminada correctamente' ,
                        'success'
                    ).then(() => {
                        window.location.reload();
                    })
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudo eliminar la noticia' ,
                        'error'
                    ).then(() => {
                        window.location.reload();
                    })
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Eliminación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        })
    }
}

export default Noticias;
